import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Subscription state — persisted so the user can launch offline and still see their plan.
// Re-fetched on every auth-state change; the persisted copy is only a stale-fallback.
const useSubscriptionStore = create(
  persist(
    (set) => ({
      subscriptionData: null,
      tier: 'free',
      iapReady: false,
      iapError: null,
      purchasing: false,
      purchaseError: null,
      showUpgradeModal: false,
      upgradeContext: '',

      setSubscriptionData: (data) =>
        set({ subscriptionData: data, tier: data?.tier || 'free' }),
      clearSubscription: () => set({ subscriptionData: null, tier: 'free' }),
      setIapReady: (ready) => set({ iapReady: ready }),
      setIapError: (err) => set({ iapError: err }),
      setPurchasing: (p) => set({ purchasing: p }),
      setPurchaseError: (e) => set({ purchaseError: e }),
      setShowUpgradeModal: (show) => set({ showUpgradeModal: show }),
      setUpgradeContext: (ctx) => set({ upgradeContext: ctx }),
    }),
    {
      name: 'cooksmith-subscription',
      partialize: (state) => ({
        subscriptionData: state.subscriptionData,
        tier: state.tier,
      }),
    }
  )
);

export default useSubscriptionStore;
